import React from 'react';

import useSupportedCurrencies from '../hooks/useSupportedCurrencies';
import { freePlanRequestsPerMonth } from '../config/plans';

function Pricing() {
  const supportedCurrencies = useSupportedCurrencies()
  const supportedKarats = '24k, 22k, 21k, 20k, 18k, 16k, 14k, 10k';
  const supportedCurrenciesCount = supportedCurrencies.count || '...'
  const plans = [
    {
      key: 'free',
      title: 'Free',
      accent: 'hl-silver',
      price: 'Free',
      icon: 'https://img.icons8.com/ios/90/000000/developer.png',
      iconAlt: 'Real-Time Gold & Silver Prices JSON API',
      badge: 'Get Started',
      featured: false,
      items: [
        ['API Requests', `Up to ${freePlanRequestsPerMonth}/month`],
        ['Metals', 'XAU, XAG, XPT, XPD'],
        ['Currencies', <span>{supportedCurrenciesCount} <span className='small'>incl. USD, EUR, INR, AED, KWD, QAR, IDR</span></span>],
        ['Karats', supportedKarats],
        ['Historical', 'Daily prices'],
        ['Updates', '2 sec interval'],
        ['WebSockets', '1 connection, 10 channels'],
        ['MCP Server', 'Not included'],
        ['Support', 'Limited']
      ]
    },
    {
      key: 'pro',
      title: 'Pro',
      accent: 'hl-gold',
      price: process.env.REACT_APP_STRIPE_PLAN_PRICE || '99',
      priceMeta: 'USD / month',
      icon: 'https://img.icons8.com/ios/90/000000/for-beginner.png',
      iconAlt: 'Historical & Real-Time Gold & Silver Prices RESTful API',
      badge: 'Unlimited REST',
      featured: false,
      items: [
        ['API Requests', 'Unlimited/month'],
        ['Metals', 'XAU, XAG, XPT, XPD'],
        ['Currencies', <span>{supportedCurrenciesCount} <span className='small'>incl. USD, EUR, INR, AED, KWD, QAR, IDR</span></span>],
        ['Karats', supportedKarats],
        ['Historical', 'Daily prices'],
        ['Updates', 'Real-time'],
        ['WebSockets', 'Not included'],
        ['MCP Server', 'Not included'],
        ['Support', 'Standard']
      ]
    },
    {
      key: 'business',
      title: 'Business',
      accent: 'hl-gold',
      price: process.env.REACT_APP_STRIPE_BUSINESS_MONTHLY_PRICE || '199',
      priceMeta: 'USD / month',
      icon: 'https://img.icons8.com/?size=100&id=58861&format=png&color=000000',
      iconAlt: 'Precious Metals REST and WebSocket API',
      badge: 'Unlimited REST + WS',
      featured: true,
      items: [
        ['API Requests', 'Unlimited/month'],
        ['Metals', 'XAU, XAG, XPT, XPD'],
        ['Currencies', <span>{supportedCurrenciesCount} <span className='small'>incl. USD, EUR, INR, AED, KWD, QAR, IDR</span></span>],
        ['Karats', supportedKarats],
        ['Historical', 'Daily prices'],
        ['Updates', 'Real-time'],
        ['WebSockets', '5 connections, 20 channels'],
        ['MCP Server', 'OAuth + API key'],
        ['Support', 'Priority']
      ]
    }
  ];

  return (
    <div className="row mt-3 mb-5 landing-pricing-grid">
      {plans.map((plan) => (
        <div key={plan.key} className="col-md-6 col-lg-4 my-2">
          <div className={`landing-pricing-card landing-pricing-plan-card h-100 ${plan.featured ? 'landing-pricing-card-featured' : ''}`}>
            <div className="landing-pricing-card-top">
              <div className="landing-card-icon-wrap landing-pricing-icon-wrap">
                <img
                  src={plan.icon}
                  width="50px"
                  alt={plan.iconAlt}
                />
              </div>
              <div className={`landing-pricing-badge ${plan.featured ? 'landing-pricing-badge-featured' : ''}`}>
                {plan.badge}
              </div>
            </div>

            <div className="landing-pricing-copy">
              <h2>
                <span className={`${plan.accent} font-weight-bold`}>{plan.title}</span>{' '}
                <span className="text-muted">Plan</span>
              </h2>
              <div className={`landing-pricing-price ${plan.featured ? 'landing-pricing-price-featured' : ''}`}>
                {plan.price !== 'Free' ? (
                  <>
                    <sup>$</sup>{plan.price}
                    <span>{plan.priceMeta}</span>
                  </>
                ) : (
                  <span className="landing-pricing-price-free">{plan.price}</span>
                )}
              </div>
            </div>

            <div className="landing-pricing-feature-list">
              {plan.items.map(([label, value]) => (
                <div key={label} className="landing-pricing-feature-row">
                  <span className="landing-pricing-feature-label">{label}</span>
                  <span className="landing-pricing-feature-value">
                    {value}
                    {label === 'Currencies' &&
                      <span className="pricing-currencies-tooltip-wrap">
                        <button className="pricing-currencies-link" type="button">see all</button>
                        <span className="pricing-currencies-tooltip" role="tooltip">
                          {supportedCurrencies.flaggedList || 'Loading...'}
                        </span>
                      </span>
                    }
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Pricing;
